import React, { useState, useEffect } from "react";
import Navbar from "../../components/Navbar/Navbar";
import { Breadcrumb, Button, Select } from "antd";
import { DoubleRightOutlined, DownloadOutlined } from "@ant-design/icons";
import ShimmerLoader from "../../loading";
import "../../styles.css";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { Link, useLocation } from "react-router-dom";
import { routes } from "../../Routes";
import LoadingSpinner from "../../components/Loading";
import {
  fetchAllVendors,
  getVendors,
} from "../../API  Functions/PurchaseFunctions";
import SearchBox from "../../components/CustomWidgets/SearchBox";
import { debounce } from "@mui/material";
import {
  cashInOutReport,
  getCreditHistory,
} from "../../API  Functions/SessionHistoryFunctions";
import CreditHistoryTable from "./CreditHistoryTable";
import CashiInOutTable from "./CashInOutTable";
import { getStoreUsers } from "../../API  Functions/UserMangement";
import ExportCasInOutReportModal from "./ExportCasInOutReportModal";
import axiosInstance from "../../AxiosInstance";
import { URLS } from "../../API/API endpoints";
import { toast } from "react-toastify";
import i18next from "i18next";
import AddNewExpense from "../../components/Setting/AddNewExpense";
import moment from "moment";
import { checkPermission } from "../../Utils/permissionHelper";

const CashiInOutReport = () => {
  const { t, i18n } = useTranslation();
  const user_id = useSelector((state) => state?.login?.user?.result?.user_id);
  const [loading, setloading] = useState(false);
  const { Option } = Select;
  const company_id = useSelector(
    (state) => state?.login?.user?.result?.company_id
  );
  const isGinne = useSelector(
    (state) => state?.geneLoginReducer?.isGinneLogin
  );

  const allStores = useSelector(
    (state) => state?.storeReducer?.selectedStore?.is_select_all_store
  )

  const [data, setData] = useState([]);
  const [currentLimit, setCurrentLimit] = useState(50); // Default limit
  const [currentOffset, setCurrentOffset] = useState(0); // Default offset
  const [query, setquery] = useState("");
  const [cashiInOutData, setCashiInOutData] = useState([]);
  const [userData, setUserData] = useState([]);
  const [selectedUser, setSelectedUser] = useState(null);
  const [exportModalOpen, setExportModalOpen] = useState(false);
  const [transactionModal, setOpenTransactionModal] = useState(false);

  // useEffect(() => {
  //   // if (user_id) {
  //   // }
  // }, [currentLimit, currentOffset]);

  useEffect(() => {
    GetUserData();
  }, []);

  const GetUserData = async () => {
    try {
      const res1 = await getStoreUsers(user_id);

      if (res1?.result[0]?.status_code === 200) {
        const activeUsers = res1.result[0]?.response?.filter(
          (user) => user.active === true
        );
        setUserData(activeUsers);
      } else {
        setUserData([]);
      }
    } catch (error) {
      console.error("Error fetching KPI data:", error);
      setloading(false);
    }
  };

  const GetCashInOutReport = async (user, text, limit, offset) => {
    const payload = {
      offset: offset,
      limit: limit,
      search: text,
      ...(user && { user_id: user }),
      // user_id: user_id,
      // search:text
    };
    try {
      const res1 = await cashInOutReport(payload);
      //   console.log("GetCreditHistory", res1?.result[0]?.status_code);

      if (res1?.result?.status_code == 200) {
        setCashiInOutData(res1?.result?.response);
      } else {
        setCashiInOutData([]);
      }
    } catch (error) {
      console.error("Error fetching KPI data:", error);
      setloading(false);
    } finally {
      setloading(false);
    }
  };

  const handleOptionChange = (selectedValue) => {
    setCurrentLimit(50);
    setCurrentOffset(0);
    setloading(true);
    if (selectedValue === "All Users") {
      setSelectedUser(null); // Reset selected category
      GetCashInOutReport(null, "", 50, 0); // Fetch all products
    } else {
      setSelectedUser(selectedValue);
      if (selectedValue) {
        GetCashInOutReport(selectedValue, "", 50, 0);
      }
    }
  };

  const debouncedSearch = debounce((value) => {
    setquery(value);
    setloading(true);
    GetCashInOutReport(selectedUser, value, 50, 0);
  }, 700);

  console.log("cashiInOutData==>", cashiInOutData);

  // ⭐ UPDATED EXPORT FUNCTION WITH ACTIVE FILTERS
  const handleExport = async (dates) => {
    let payload = {
      lang: i18next.language === "ar" ? "ar_001" : "en_US",
      company_id: company_id,
      start_date: dates?.startDate,
      end_date: dates?.endDate,

      // 🔥 Pass current live UI filter text string state
      search: query || "",

      // 🔥 Mirror user conditional filter logic from GetCashInOutReport function
      ...(selectedUser && { user_id: selectedUser }),
    };

    try {
      const response = await axiosInstance.post(URLS.POS_CASH_IN_OUT_EXCEL, payload);
      console.log("handleExport response:", response);
      
      if (response?.data?.result?.status_code == 200) {
        setExportModalOpen(false);
        downloadFile(response?.data?.result?.file);
      } else {
        toast.error(response?.data?.result?.status || t("Export failed"));
      }
    } catch (error) {
      console.error("Cash In/Out export error:", error);
      toast.error(t("Something went wrong while exporting"));
    }
  };
  const downloadFile = (base64Data) => {
    try {
      if (
        !base64Data ||
        typeof base64Data !== "string" ||
        base64Data.trim() === ""
      ) {
        alert("No valid file data available for download");
        return;
      }

      let cleanBase64 = base64Data
        .trim()
        .replace(/^data:[\w/+-]+;base64,/, "")
        .replace(/^["']|["']$/g, "")
        .replace(/\s/g, "");

      const padLength = 4 - (cleanBase64.length % 4);
      if (padLength < 4) cleanBase64 += "=".repeat(padLength);

      let binaryString = atob(cleanBase64);
      const bytes = new Uint8Array(binaryString.length);
      for (let i = 0; i < binaryString.length; i++) {
        bytes[i] = binaryString.charCodeAt(i);
      }

      const header = new Uint8Array(bytes.buffer, 0, 8);
      let mimeType = "application/octet-stream";
      let fileExtension = "bin";

      if (header[0] === 0x50 && header[1] === 0x4b) {
        mimeType =
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
        fileExtension = "xlsx";
      } else if (
        header[0] === 0xd0 &&
        header[1] === 0xcf &&
        header[2] === 0x11 &&
        header[3] === 0xe0
      ) {
        mimeType = "application/vnd.ms-excel";
        fileExtension = "xls";
      } else if (new TextDecoder().decode(header).includes(",")) {
        mimeType = "text/csv";
        fileExtension = "csv";
      }

      const blob = new Blob([bytes], { type: mimeType });
      // const timestamp = new Date()
      //   .toISOString()
      //   .replace(/[:.]/g, "-")
      //   .replace("T", "_")
      //   .slice(0, 19);
      // const timestamp = moment().format('YYYY-MM-DD_HH:mm:ss'); 
      const timestamp = moment().format('YYYY-MM-DD_HH.mm.ss'); // Using period for time

      const filename = `${t('cash_in_out')}_${timestamp}.${fileExtension}`;
      const url = URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = url;
      link.download = filename;
      document.body.appendChild(link);
      link.click();
      setTimeout(() => {
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
      }, 100);
    } catch (error) {
      console.error("File download failed:", error);
      alert(`Download failed: ${error.message || "Unknown error"}`);
    }
  };
  return (
    <>
      <div className="flex w-full flex-col overflow-y-auto bg-[#F6F7F9] pb-2 md:h-full">
        <Navbar heading="Cash In/Out Report" />
        <div className="custom-scrollbar mx-2 flex-grow overflow-y-auto overflow-hidden md:ms-3 sm:mx-0 ">
          {/* <div className="font-extrabold mb-3">
            <Breadcrumb
              separator={<DoubleRightOutlined />}
              items={[
                {
                  title: <Link to={routes.purchase}>{t("Cashier")}</Link>,
                  key: "purchase",
                },
                { title: t("Cash In/Out Report") },
              ]}
              className="relative mt-3 font-semibold"
            />
          </div> */}

          <div className="mt-6">
            <div className="me-1 flex flex-col gap-3 sm:me-3 md:me-8 md:flex-row md:items-start md:justify-between">
              <div className="flex w-full flex-col gap-2 md:w-auto md:flex-row">
                <SearchBox
                  // showBarcode={true}
                  searchResult={(values) => debouncedSearch(values)}
                  placeholder={t("Search Session/Cashier")}
                />
                <div className="w-full md:mx-3 md:w-auto">
                  <Select
                    className="w-full overflow-hidden"
                    style={{
                      width: "100%",
                      maxWidth: 250,
                      minWidth: 200,
                      height: 40,
                    }}
                    placeholder={t("Select User")}
                    value={selectedUser || "All Users"} // Set default value to "All Categories"
                    onChange={handleOptionChange} // Keep this as is
                  >
                    <Option value="All Users">{t("All Users")}</Option>{" "}
                    {/* Add All Categories option */}
                    {Object.values(userData)?.map((option) => (
                      <Option key={option.user_id} value={option.user_id}>
                        {option.name} (
                        {option.phone ? option.phone : option.email})
                      </Option>
                    ))}
                  </Select>
                </div>
              </div>
              <div className="flex w-full gap-3 md:w-auto md:justify-end">
                {/* <button
                  className="w-48 h-10 bg-primaryBlue text-white text-sm font-semibold rounded-lg flex items-center justify-center gap-2"
                  onClick={() => setOpenTransactionModal(true)}
                >
                  <span>{t("Cash In/Out")}</span>
                </button> */}
                <button
                  className="flex h-10 w-full items-center justify-center gap-2 rounded-lg bg-primaryBlue text-sm font-semibold text-white sm:w-48"
                  // onClick={() => setExportModalOpen(true)}
                  // onClick={() => {
                  //   if (checkPermission("/pos/credithistory", isGinne)) {
                  //     setExportModalOpen(true);
                  //   }
                  // }}
                  onClick={() => {
                    if (allStores) {
                      // If allStores is true, directly open the export modal
                      setExportModalOpen(true);
                    } else {
                      // Otherwise, check permission before opening the export modal
                      if (checkPermission("/pos/credithistory", isGinne)) {
                        setExportModalOpen(true);
                      }
                    }
                  }}

                >
                  <DownloadOutlined
                    style={{ fontSize: "1.5em", MozMarginStart: -10 }}
                  />

                  <span>{t("Download in Excel")}</span>
                </button>
              </div>
            </div>
            {loading ? (
              <ShimmerLoader />
            ) : (
              <>
                <CashiInOutTable
                  additionalData={cashiInOutData}
                  pagination={(values) => {
                    setCurrentLimit(values.limit);
                    setCurrentOffset(values.offset);
                    GetCashInOutReport(
                      selectedUser,
                      query,
                      values.limit,
                      values.offset
                    );
                  }}
                />
              </>
            )}
          </div>
        </div>
        {exportModalOpen && (
          <ExportCasInOutReportModal
            heading={t("Download Cash In/Out Report")}
            isOpen={exportModalOpen}
            onClose={() => setExportModalOpen(false)}
            onExport={(dates) => handleExport(dates)}
          />
        )}
        {transactionModal && (
          <AddNewExpense
            isOpen={transactionModal}
            onClose={() => setOpenTransactionModal(false)}
            userData={userData}
            ExpenseUpdated={() => {
              setOpenTransactionModal(false);
              setCurrentLimit(50);
              setCurrentOffset(0);
              setSelectedUser(null);
              setquery("");
              GetCashInOutReport(null, "", 50, 0);
            }}
          />
        )}
      </div>
    </>
  );
};

export default CashiInOutReport;
